import "./riaddbox.styles.scss";
const RIAddBox = ({ submitfunction, changeFunction, unitsObject, fields }) => {
  const { name, toBuyDate, quantity, unit } = fields;
  return (
    <div className="ri-buylist-add">
      <form onSubmit={submitfunction} className="ri-buylist-add-form">
        <div className="ri-buylist-add-item-details">
          <input
            type="text"
            name="name"
            value={name}
            placeholder="New item"
            className="ri-buylist-input"
            onChange={changeFunction}
          />
          <input
            type="date"
            name="toBuyDate"
            placeholder="Buy before"
            value={toBuyDate}
            className="ri-buylist-input"
            onChange={changeFunction}
          />
        </div>

        <div className="ri-buylist-add-quantity">
          <input
            type="number"
            name="quantity"
            value={quantity}
            className="ri-buylist-input"
            onChange={changeFunction}
          />
          <select
            name="unit"
            value={unit}
            className="ri-buylist-input"
            onChange={changeFunction}
          >
            {Object.keys(unitsObject).map((index) => {
              return (
                <option key={index} value={index}>
                  {index}
                </option>
              );
            })}
          </select>
        </div>
        <button className="ri-buylist-submit" type="submit">
          Add Item
        </button>
      </form>
    </div>
  );
};
export default RIAddBox;
